import { useState, useEffect } from "react";
export default function useIsMobile(bp = 768) {
  const [m, setM] = useState(window.innerWidth <= bp);
  useEffect(() => {
    const h = () => setM(window.innerWidth <= bp);
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
  }, [bp]);
  return m;
}
